import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import { Board } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";

@Component({
    name: 'BoardCreateModal',
    components: { vSelect }
})
export default class BoardCreateModal extends Vue {
    @Prop({ required: true })
    private readonly state!: KanbanState;

    //runtime
    private boardName: string = '';
    private selectedTemplate: string | null = null;
    private loadingSymbol: boolean = false;

    public open(boardName: string | undefined): void {
        this.boardName = boardName ?? '';
        $(this.$refs.modal!).modal('show');
    }

    public dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }

    public showLoadingSymbol(): void {
        this.loadingSymbol = true;
    }

    public hideLoadingSymbol(): void {
        this.loadingSymbol = false;
    }

    private get templates(): Board[] {
        return this.state.templates;
    }

    private create(): void {
        this.$emit('create-board', { name: this.boardName, templateId: this.selectedTemplate });
    }
}